// In: src/components/chat/LearningSuggestion.tsx
'use client';

import React, { useState } from 'react';
import { LightBulbIcon } from '@heroicons/react/24/solid';
import { Button } from '../ui/Button';

interface LearningSuggestionProps {
  suggestion: string;
  onConfirm: () => Promise<void>;
  onDismiss: () => void;
}

export const LearningSuggestion = ({ suggestion, onConfirm, onDismiss }: LearningSuggestionProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    // The parent component will handle hiding this component
  };

  return (
    <div className="my-4 p-4 rounded-lg bg-info/10 border border-info/40 animate-in fade-in-0 duration-500">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-info/20 flex items-center justify-center ring-1 ring-info/30">
          <LightBulbIcon className="h-5 w-5 text-info" />
        </div>
        <div className="flex-1">
          <p className="font-medium text-sm text-foreground">Learning Opportunity</p>
          <p className="text-sm text-muted-foreground mt-1">{suggestion}</p>
          <div className="flex items-center gap-2 mt-4">
            <Button onClick={handleConfirm} disabled={isLoading}>
              {isLoading ? 'Updating...' : 'Yes, Update Profile'}
            </Button>
            <Button onClick={onDismiss} disabled={isLoading} variant="ghost">
              Dismiss
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};